// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"3eee0b1a","152":"18949040","164":"73bb4cfb","328":"1f649f8e","339":"fbdb1533","608":"c926ca9c","646":"49f1c661","675":"c01c6599","733":"247fc45c","744":"259cb682","804":"744e17cf","895":"b5a204c5"}[chunkId] + ".chunk.js";
};